import React from 'react';
import styles from './page.module.scss';
import { LoadImgWithFallback } from '@brahma/components';
import { TM_MostCommon_Images } from '$constants/images.constants';
import { DATAFLOW_OPERATIONS_TRAINING } from './onboardingConstants';
import SsoLogin from '../sso-login';
import Image from 'next/image';
function Onboarding() {
  return <div className={styles.OnboardContainer} data-sentry-component="Onboarding" data-sentry-source-file="page.tsx">
      <div className={styles.OnboardNavbar}>
        <LoadImgWithFallback imageUrl={TM_MostCommon_Images.dataflow_name_logo} alt="Dataflow_Logo" style={{
        width: '190px',
        height: '40px'
      }} testId="dataflow-logo" data-sentry-element="LoadImgWithFallback" data-sentry-source-file="page.tsx" />
      </div>
      <div className={styles.OnboardMainPage}>
        <div className={styles.OnboardMainPageLeftSide}>
          <Image src={TM_MostCommon_Images.opsStartScreen} alt="Dataflow Start Screen" className={styles.OnboardMainPageLeftSideBackgroundLogo} width={100} height={100} data-sentry-element="Image" data-sentry-source-file="page.tsx" />
          {/* <LoadImgWithFallback
            imageUrl={TM_MostCommon_Images.opsStartScreen}
            alt="Dataflow_Logo"
            className={styles.OnboardMainPageLeftSideBackgroundLogo}
            style={{ width: '100px', height: '100px' }}
            testId="dataflow-logo"
           /> */}
          <p className={styles.OnboardMainPageLeftSideHeading}>
            {DATAFLOW_OPERATIONS_TRAINING}
          </p>
        </div>
        <div className={styles.OnboardMainPageRightSide}>
          <SsoLogin data-sentry-element="SsoLogin" data-sentry-source-file="page.tsx" />
        </div>
      </div>
    </div>;
}
export default Onboarding;